import { render, staticRenderFns } from "./Scoring.vue?vue&type=template&id=304421cc&scoped=true&"
import script from "./Scoring.vue?vue&type=script&lang=js&"
export * from "./Scoring.vue?vue&type=script&lang=js&"
import style0 from "./Scoring.vue?vue&type=style&index=0&id=304421cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304421cc",
  null
  
)

export default component.exports